import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { NetworkPOPResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post } from "./common";

export const networkPOP = {
    record(data: typeof Requests.NetworkPOP.Record.Input) {
        return post<typeof data, NetworkPOPResponseTypes.Record>(`/network-pop/record`, data);
    },
    create(data: typeof Requests.NetworkPOP.Create.Input) {
        return post<typeof data>(`/network-pop/create`, data);
    },
    obtain(id: string) {
        return get<NetworkPOPResponseTypes.Obtain>(`/network-pop/obtain/${id}`);
    },
    coords(data: typeof Requests.NetworkPOP.Coords.Input) {
        return post<typeof data, NetworkPOPResponseTypes.Coords>(`/network-pop/coords`, data);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<NetworkPOPResponseTypes.Select>(
                `/network-pop/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.NetworkPOP.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/network-pop/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
